import type { ActionFunction, LoaderFunction } from 'remix';
import { Form, json, useActionData, useLoaderData } from 'remix';
import Button from '~/components/Button';
import Input from '~/components/Input';
import { userModel } from '~/models/user.server';
import { createApi } from '~/util/api.server';

export const loader: LoaderFunction = async ({ request }) => {
  const api = createApi(request);
  if (await api.isLoggedIn()) {
    const currentUser = await userModel.currentUser(request);
    return { currentUser };
  }
  return { currentUser: null };
};

export const action: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const username = String(formData.get('username')).trim();

  if (username?.indexOf('@') < 0) {
    return json(
      {
        errors: true,
        message:
          'Der angegebene Account wird möglicherweise durch einen externen Provider (z. B. Mantis) bereitgestellt. Das Passwort konnte nicht zurückgesetzt werden.',
      },
      404,
    );
  }

  const api = createApi(request);
  const resp = await api.forgotPassword({
    email: username,
  });
  if (resp.status === 200) {
    return json({ success: 'ok' });
  }
  return json(
    {
      errors: true,
      message:
        'Der angegebene Account existiert nicht oder ein anderer Fehler ist aufgetreten!',
    },
    404,
  );
};

export default function ForgotPassword() {
  const loaderData = useLoaderData();
  const actionData = useActionData();

  const username = loaderData?.currentUser?.username;

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <div className="w-96 rounded-md bg-white p-6 shadow-md">
        <h2 className="mb-4 text-2xl">Passwort zurücksetzen</h2>
        {username ? null : (
          <p className="mb-6">
            Bitte geben Sie die E-Mail-Adresse Ihres Benutzerkontos an. Sie
            erhalten eine E-Mail, um Ihr Passwort zurückzusetzen.
          </p>
        )}

        <Form method="post">
          {username ? (
            <>
              <input type="hidden" name="email" value={username} />
              <div className="mb-6">
                Die E-Mail, um Ihr Passwort zurückzusetzen, wird an
                <strong> {username} </strong> gesendet.
              </div>
            </>
          ) : (
            <Input
              type="text"
              name="username"
              id="username"
              label="Benutzer"
              autoComplete="username"
              className="mb-6"
            />
          )}

          {actionData?.errors ? (
            <div className="mb-6 text-sm">
              <p className="mb-4 text-red-500">
                {actionData?.message ||
                  'Der angegebene Account existiert nicht oder ein anderer Fehler ist aufgetreten!'}
              </p>
            </div>
          ) : null}

          {actionData?.success ? (
            <div className="text-sm">
              <p className="text-green-500">E-Mail erfolgreich verschickt!</p>
            </div>
          ) : (
            <Button type="submit">E-Mail anfordern</Button>
          )}
        </Form>
      </div>
    </div>
  );
}
